import React from "react";
import { Container, Navbar } from "react-bootstrap";
//import { Link } from "react-router-dom";
import "./Navbar.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../logo.svg";


export default function Navar() {
  return (
    <>
      <Navbar className="bg-nav">
        <div className="my-1 mx-2 mx-md-3 mx-lg-5">
          <Navbar.Brand href="#home">
            <img
              src={logo}
              style={{height:32}}
              className="d-inline-block align-top"
              alt="Proctorme"
            />
          </Navbar.Brand>
        </div>
      </Navbar>      
    </>
  );
}
